import React from 'react';
import { IIconProps } from '../interfaces';

const EmailIcon = (props: IIconProps) => {
  return (
      <svg
          width={ props.width }
          height={ props.width }
          viewBox="0 0 17 13"
          className={ props.classes }
          style={ props.style }
          xmlns="http://www.w3.org/2000/svg"><path d="M1.768 0C.798 0 0 .868 0 1.92v8.535c0 1.052.799 1.92 1.768 1.92h12.964c.97 0 1.768-.868 1.768-1.92V1.92C16.5.868 15.701 0 14.732 0H1.768zm.129 1.28h12.712L8.612 7.094c-.228.222-.482.222-.712 0L1.897 1.28zM1.179 2.3l4.039 3.914-4.04 4.214V2.3zm14.142 0v8.121l-4.026-4.214L15.32 2.3zm-4.91 4.768 3.849 4.027H2.24l3.861-4.02 1.013.98c.644.623 1.64.624 2.284 0l1.013-.987z" fill={ props.color } fillRule="evenodd"/>
      </svg>
  )
};

export default EmailIcon;